<template>
  <div class="country">
    <div class="list">
      <div class="title bold text-left">Choose your country</div>
      <van-index-bar :index-list="indexList">
        <van-index-anchor index="A" v-if="dataA.length > 0">A</van-index-anchor>
        <van-cell v-for="item in dataA" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="B" v-if="dataB.length > 0">B</van-index-anchor>
        <van-cell v-for="item in dataB" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="C" v-if="dataC.length > 0">C</van-index-anchor>
        <van-cell v-for="item in dataC" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="D" v-if="dataD.length > 0">D</van-index-anchor>
        <van-cell v-for="item in dataD" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="E" v-if="dataE.length > 0">E</van-index-anchor>
        <van-cell v-for="item in dataE" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="F" v-if="dataF.length > 0">F</van-index-anchor>
        <van-cell v-for="item in dataF" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="G" v-if="dataG.length > 0">G</van-index-anchor>
        <van-cell v-for="item in dataG" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="H" v-if="dataH.length > 0">H</van-index-anchor>
        <van-cell v-for="item in dataH" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="I" v-if="dataI.length > 0">I</van-index-anchor>
        <van-cell v-for="item in dataI" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="J" v-if="dataJ.length > 0">J</van-index-anchor>
        <van-cell v-for="item in dataJ" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="K" v-if="dataK.length > 0">K</van-index-anchor>
        <van-cell v-for="item in dataK" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="L" v-if="dataL.length > 0">L</van-index-anchor>
        <van-cell v-for="item in dataL" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="M" v-if="dataM.length > 0">M</van-index-anchor>
        <van-cell v-for="item in dataM" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="N" v-if="dataN.length > 0">N</van-index-anchor>
        <van-cell v-for="item in dataN" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="O" v-if="dataO.length > 0">O</van-index-anchor>
        <van-cell v-for="item in dataO" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="P" v-if="dataP.length > 0">P</van-index-anchor>
        <van-cell v-for="item in dataP" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="Q" v-if="dataQ.length > 0">Q</van-index-anchor>
        <van-cell v-for="item in dataQ" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="R" v-if="dataR.length > 0">R</van-index-anchor>
        <van-cell v-for="item in dataR" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="S" v-if="dataS.length > 0">S</van-index-anchor>
        <van-cell v-for="item in dataS" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="T" v-if="dataT.length > 0">T</van-index-anchor>
        <van-cell v-for="item in dataT" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="U" v-if="dataU.length > 0">U</van-index-anchor>
        <van-cell v-for="item in dataU" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="V" v-if="dataV.length > 0">V</van-index-anchor>
        <van-cell v-for="item in dataV" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="W" v-if="dataW.length > 0">W</van-index-anchor>
        <van-cell v-for="item in dataW" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="X" v-if="dataX.length > 0">X</van-index-anchor>
        <van-cell v-for="item in dataX" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="Y" v-if="dataY.length > 0">Y</van-index-anchor>
        <van-cell v-for="item in dataY" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
        <van-index-anchor index="Z" v-if="dataZ.length > 0">Z</van-index-anchor>
        <van-cell v-for="item in dataZ" :key="item.value" :title="item.text"
                  :value="item.value"
                  @click="click(item.text, item.value)" />
      </van-index-bar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'country',
  data () {
    return {
      example: '全球城市（如北京/beijing）',
      country: '',
      marketItems: null,
      indexList: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      dataA: [],
      dataB: [],
      dataC: [],
      dataD: [],
      dataE: [],
      dataF: [],
      dataG: [],
      dataH: [],
      dataI: [],
      dataJ: [],
      dataK: [],
      dataL: [],
      dataM: [],
      dataN: [],
      dataO: [],
      dataP: [],
      dataQ: [],
      dataR: [],
      dataS: [],
      dataT: [],
      dataU: [],
      dataV: [],
      dataW: [],
      dataX: [],
      dataY: [],
      dataZ: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 获取所有市场
    getListMarket (params) {
      return this.$http.post('/olvp/getListMarket', 'getListMarket', params, false, false)
    },
    loadData () {
      this.getMarket()
      this.$Staticdata.data.countrys.map((v) => {
        let first = v.text.substr(0, 1)
        if (first === 'A') {
          this.dataA.push(v)
        } else if (first === 'B') {
          this.dataB.push(v)
        } else if (first === 'C') {
          this.dataC.push(v)
        } else if (first === 'D') {
          this.dataD.push(v)
        } else if (first === 'E') {
          this.dataE.push(v)
        } else if (first === 'F') {
          this.dataF.push(v)
        } else if (first === 'G') {
          this.dataG.push(v)
        } else if (first === 'H') {
          this.dataH.push(v)
        } else if (first === 'I') {
          this.dataI.push(v)
        } else if (first === 'J') {
          this.dataJ.push(v)
        } else if (first === 'K') {
          this.dataK.push(v)
        } else if (first === 'L') {
          this.dataL.push(v)
        } else if (first === 'M') {
          this.dataM.push(v)
        } else if (first === 'N') {
          this.dataN.push(v)
        } else if (first === 'O') {
          this.dataO.push(v)
        } else if (first === 'P') {
          this.dataP.push(v)
        } else if (first === 'Q') {
          this.dataQ.push(v)
        } else if (first === 'R') {
          this.dataR.push(v)
        } else if (first === 'S') {
          this.dataS.push(v)
        } else if (first === 'T') {
          this.dataT.push(v)
        } else if (first === 'U') {
          this.dataU.push(v)
        } else if (first === 'V') {
          this.dataV.push(v)
        } else if (first === 'W') {
          this.dataW.push(v)
        } else if (first === 'X') {
          this.dataX.push(v)
        } else if (first === 'Y') {
          this.dataY.push(v)
        } else if (first === 'Z') {
          this.dataZ.push(v)
        }
      })
    },
    getMarket () {
      this.getListMarket({}).then((d) => {
        if (d.success) {
          this.marketItems = d.content.marketList
        }
      })
    },
    click (name, code) {
      this.$util.storageSet('local', 'country', name)
      this.$util.storageSet('local', 'phoneCode', code)
      this.marketItems.map((v) => {
        if (v.internationalAreaCode === code) {
          this.$util.storageSet('local', 'marketCode', v.marketCode)
          this.$util.storageSet('local', 'marketImg', v.marketUrlImage)
          this.$util.storageSet('local', 'marketId', v.marketId)
        }
      })
      if (this.$route.query.change) {
        this.$router.replace('/home')
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="scss">
  .country {
    background: #f7f7f7;
    height: 100%;
    width: 100%;
    .title {
      font-size: 24px;
    }
  }
  .list {
    background: #fff;
    padding: 10px;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    ul li {
      border-bottom: 1px solid #eee;
      padding: 15px 0;
    }
    ul li:last-child {
      border: none;
    }
  }

  .van-cell .van-cell__value {
    font-size: 12px;
  }
  .van-index-bar .van-index-bar__sidebar .van-index-bar__index {
    font-size: 14px;
    margin-bottom: 3px;
  }
</style>
